import { FC, useMemo } from 'react';
import { useForm } from 'react-hook-form';
import Modal from 'components/Modal';
import Input from 'components/inputs/Input';
import LabelWrap from 'components/inputs/LabelWrap';
import {
  useCarTransportTruckCreate,
  useCarTransportTruckUpdate,
} from 'api/car-transport-truck/car-transport-truck';
import styled from 'styled-components';
import { CarTransportTruckModel } from 'api/model';

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  min-width: 300px;
`;

interface Props {
  truck?: CarTransportTruckModel | null;
  onClose: () => void;
}

const CarTransportTruckFormModal: FC<Props> = ({ truck, onClose }) => {
  const isEdit = !!truck;
  const createTruckCall = useCarTransportTruckCreate();
  const updateTruckCall = useCarTransportTruckUpdate();

  const { handleSubmit, register } = useForm<CarTransportTruckModel>({
    defaultValues: truck ?? undefined,
  });

  const onSubmit = handleSubmit(async (data) => {
    if (isEdit) {
      await updateTruckCall.mutateAsync({
        data: {
          ...data,
        },
      });
    } else {
      await createTruckCall.mutateAsync({
        data: {
          ...data,
        },
      });
    }
    onClose();
  });

  // Optionally disable form if truck is not editable
  const shouldBeDisabled = useMemo(() => false, []);

  return (
    <Modal
      title={isEdit ? 'Redigera' : 'Lägg till'}
      onClose={onClose}
      buttons={[
        {
          label: isEdit ? 'Spara' : 'Lägg till',
          disabled: shouldBeDisabled,
          loading: createTruckCall.isLoading || updateTruckCall.isLoading,
          onClick: () => onSubmit(),
        },
        { label: 'Avbryt', onClick: onClose },
      ]}
    >
      <ContentWrapper>
        <LabelWrap label="Regnr">
          <Input
            width="100%"
            disabled={shouldBeDisabled}
            {...register('registrationNumber')}
          />
        </LabelWrap>
        <LabelWrap label="Max antal bilar">
          <Input
            width={50}
            type="number"
            disabled={shouldBeDisabled}
            {...register('maxNumberOfCars')}
          />
        </LabelWrap>
      </ContentWrapper>
    </Modal>
  );
};

export default CarTransportTruckFormModal;
